import api from '../../../helpers/api';

// export const getPublicInquiries = (body) =>
//   api.post("moderation-pool/get-pending-artisans-public-inquiry", { ...body });

// export const getPublicInquiries = (body) =>
//   api.post("public-artisan-inquiry-staging/search-artisan-public-inquiries", { ...body });
export const getPublicInquiries = body =>
  api.post('public-artisan-inquiry-staging/search-artisan-public-inquiries/', {
    ...body
  });
export const updatePublicInquiry = body =>
  api.post('moderation-pool/moderate-artisans-public-inquiry', { ...body });

export const getSinglePendingPublicArtsianInquiry = id =>
  api.get(`public-artisan-inquiry-staging/${id}`);

export const deleteSingleArtisanPublicInquiry = ({ _id, url }) => {

  if (url)
    return api.put(`${url ? url : 'public-supplier-inquiry-staging'}/${_id}`);
  return api.delete(`${url ? url : 'public-artisan-inquiry-staging'}/${_id}`);
};

export const moderateCreateSingleArtisanPublicIquiry = id =>
  api.post(`public-artisan-inquiry-staging/moderate-create`, id);

export const moderateUpdateSingleArtisanPublicIquiry = id =>
  api.post(`public-artisan-inquiry-staging/moderate-update`, id);
